import WhyUs from "../../Components/WhyUs/WhyUs";
import "./Services.css";
import React, { useState } from "react";
import serv1 from "../../img/1.jpg";
const Servicess = () => {
  return (
    <>
      <section className="text-center services">
        <div className="container">
          <div>
            <h2 className="title">خدماتنا المتكاملة</h2>

            <p className="my-3 fs-3">
              نحن شريكك الموثوق في عالم الشحن والخدمات اللوجستية. اتصل بنا
              اليوم!
            </p>
          </div>
          <div className="row align-items-center">
            <div className="col-md-4">
              <div className="img">
                <img src={serv1} alt="" />
              </div>
            </div>
            <div className="col-md-8">
              <div className=" row ">
                <div className="col-lg-4 col-md-6 ">
                  <div className="crd">
                    <div className="icon">
                      <i className="fas fa-shipping-fast fa-2x mb-2"></i>
                    </div>
                    <h4>الشحن السريع</h4>
                    <p>
                      نضمن توصيل شحناتك بأقصى سرعة ممكنة، سواء داخل الرياض أو
                      إلى أي وجهة في المملكة.
                    </p>
                  </div>
                </div>

                <div className="col-lg-4 col-md-6">
                  <div className="crd">
                    <div className="icon">
                      <i className="fas fa-globe fa-2x mb-2"></i>
                    </div>
                    <h4>الشحن الدولي</h4>
                    <p>
                      نقدم خدمات شحن دولية شاملة، بدءًا من التخليص الجمركي وحتى
                      التسليم النهائي في بلد المقصد.
                    </p>
                  </div>
                </div>

                <div className="col-lg-4 col-md-6">
                  <div className="crd">
                    <div className="icon">
                      <i className="fas fa-plane fa-2x mb-2"></i>
                    </div>
                    <h4>الشحن الجوي والبحري والبري</h4>
                    <p>نوفر خيارات شحن متنوعة لتلبية احتياجاتك وميزانيتك.</p>
                  </div>
                </div>

                <div className="col-lg-4 col-md-6">
                  <div className="crd">
                    <div className="icon">
                      <i className="fas fa-warehouse fa-2x mb-2"></i>
                    </div>
                    <h4>تخزين البضائع</h4>
                    <p>
                      نمتلك مستودعات حديثة وآمنة لتخزين بضائعك لفترات قصيرة أو
                      طويلة الأجل.
                    </p>
                  </div>
                </div>

                <div className="col-lg-4 col-md-6">
                  <div className="crd">
                    <div className="icon">
                      <i className="fas fa-box fa-2x mb-2"></i>
                    </div>
                    <h4>التغليف والتعبئة الاحترافية</h4>
                    <p>
                      نضمن سلامة بضائعك باستخدام مواد تغليف عالية الجودة وتقنيات
                      تعبئة احترافية.
                    </p>
                  </div>
                </div>

                <div className="col-lg-4 col-md-6">
                  <div className="crd">
                    <div className="icon">
                      <i className="fas fa-shield-alt fa-2x mb-2"></i>
                    </div>
                    <h4>التأمين على الشحنات</h4>
                    <p>
                      نوفر لك خيارات تأمين شاملة لحماية شحناتك من أي مخاطر
                      محتملة.
                    </p>
                  </div>
                </div>

                <div className="col-lg-4 col-md-6">
                  <div className="crd">
                    <div className="icon">
                      <i className="fas fa-map-marker-alt fa-2x mb-2"></i>
                    </div>
                    <h4>تتبع الشحنات</h4>
                    <p>
                      يمكنك تتبع شحناتك في الوقت الفعلي عبر نظامنا المتطور
                      لمعرفة موقعها وحالتها في أي وقت.
                    </p>
                  </div>
                </div>

                <div className="col-lg-4 col-md-6">
                  <div className="crd">
                    <div className="icon">
                      <i className="fas fa-cogs fa-2x mb-2"></i>
                    </div>
                    <h4>حلول لوجستية مخصصة</h4>
                    <p>
                      نقدم حلولًا لوجستية مخصصة لتلبية احتياجاتك الفريدة، سواء
                      كنت فردًا أو شركة.
                    </p>
                  </div>
                </div>

                <div className="col-lg-4 col-md-6">
                  <div className="crd">
                    <div className="icon">
                      <i className="fas fa-headset fa-2x mb-2"></i>
                    </div>
                    <h4>خدمة عملاء متميزة</h4>
                    <p>
                      فريقنا متاح على مدار الساعة لتقديم الدعم والإجابة على
                      استفساراتك.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <WhyUs />
    </>
  );
};

export default Servicess;
